//constants
import { SEND_INVITATION_ACTION,ACCEPT_DECLINE_ACTION } from "./Constants";

const INITIAL_STATE = {
    data: {},
    error:{}
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case SEND_INVITATION_ACTION:
            let data = action.data;
            let error = action.error
            return {
                ...state,
                data:data,
                error:error
            };

        case ACCEPT_DECLINE_ACTION:
            return {
                ...state,
                data:action.data,
                error:action.error
            };
        default:
            return state;
    }
}